import { Formik } from 'formik'
import React from 'react'
import { useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { resetPassword } from '../../Redux/action/Auth'

const ResetPassword = () => {

    const dispatch = useDispatch()
    const params = useParams()
    const history = useHistory()

    return (
        <div id="user-registration-section_1-signup-step6" className="container-lg">
            <div className="row no-gutters">
                <div className="col-xl-1 col-md-12">
                    <div className="user-registration-card-bg">
                        <img alt="" className="p-4" src="/images/dots-variant-1.svg" />
                    </div>
                </div>
                <div className="col-xl-5 col-lg-6 col-md-12 col-12">
                    <div className="py-md-6 mx-3 has-box-shadow">
                        <div className="form-heading my-5">
                            <h3 className="font-weight-bold text-dark">
                                Reset your password
                            </h3>
                            <h3 className="font-weight-bold text-dark">
                                for seam less experience
                            </h3>
                        </div>
                        <Formik
                            initialValues={{
                                password: "",
                                passwordConfirm: ""
                            }}
                            onSubmit={async ( values ) => {
                                const { password, passwordConfirm } = values
                                if ( !password ) {
                                    toast.error( "Please Enter Password" )
                                } else if ( passwordConfirm !== password ) {
                                    toast.error( "Password and Confirm password not matched" )
                                } else if ( password.length < 6 ) {
                                    toast.error( 'Password should be a minimum of six characters.' );
                                } else {
                                    await dispatch( resetPassword( values, params.token ) )
                                        .then(
                                            response => {
                                                if ( response === "Invalid Token or Link is Expired" ) {
                                                    toast.error( response )
                                                } else {
                                                    console.log( response );
                                                    toast.success( response.message )
                                                    history.push( "/login" )
                                                }
                                            },
                                            error => {
                                                console.log( "error", error );
                                            }
                                        )
                                        .catch(
                                            error => console.log( "error", error )
                                        )
                                }
                            }}
                        >
                            {( {
                                handleChange,
                                values,
                                handleSubmit
                            } ) => (
                                <form className="my-3" onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            className="form-control secondary-input"
                                            id="email-id"
                                            placeholder="Password"
                                            name="password"
                                            values={values.password}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            className="form-control secondary-input"
                                            id="email-id"
                                            placeholder="Confirm Password"
                                            name="passwordConfirm"
                                            values={values.passwordConfirm}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <button
                                        id="signup-button"
                                        className="btn btn-gradient-secondary w-100 my-5">
                                        Change Password
                                    </button>
                                </form>
                            )}
                        </Formik>
                    </div>
                </div>
                <div className="col-lg-6 col-12 text-center text-lg-left">
                    <div className="registration-artwork-top bg-dots-variant-1 bg-position-center-right-offset bg-repeat-no-repeat p-5">
                        <h2>Take a break from</h2>
                        <h2>financial work, and focus</h2>
                        <h2>
                            on{' '}
                            <span className="font-weight-bold">
                                what matters the most
                            </span>
                        </h2>
                    </div>
                    <div className="registration-artwork-bottom">
                        <img
                            alt="User Registration Artwork"
                            className="img-fluid w-90"
                            src="/images/User-Registration-Artwork.svg"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ResetPassword
